// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_3UDq0Gqo_AvtM2DYBPQnzJ","radio":"_3_p21ekvDM7UsKppiI8xW"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Style/CheckBox/CheckBox.scss
// module id = 2121
// module chunks = 1